<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_910')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_532')" v-bind="formItemLayout">
          <a-input v-decorator="decorators.name" :placeholder="$t('scope.text_911')" />
        </a-form-item>
        <a-form-item label="AccessKeyID" v-bind="formItemLayout">
          <div slot="extra">{{$t('scope.text_912')}}<help-link :href="docs['aliyun']">{{$t('scope.text_433')}}</help-link>
          </div>
          <a-input v-decorator="decorators.access_key_id" :placeholder="$t('scope.text_913')" />
        </a-form-item>
        <a-form-item label="AccessKeySecret" v-bind="formItemLayout">
          <a-input-password v-decorator="decorators.access_key_secret" :placeholder="$t('scope.text_914')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_545')" v-bind="formItemLayout">
          <a-switch :checkedChildren="$t('scope.text_699')" :unCheckedChildren="$t('scope.text_700')" v-decorator="decorators.enable_auto_sync" />
        </a-form-item>
        <a-form-item v-bind="offsetLayout">
          <a-button :loading="testLoding" style="padding: 0" type="link" @click="handleTest">{{$t('scope.text_524')}}</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
// import { CLOUDACCOUNT_DOCS } from '@Cloudenv/views/cloudaccount/constants'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'AssociateSubAccountDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      testLoding: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        name: [
          'name',
          {
            rules: [
              { required: true, message: this.$t('scope.text_911') },
            ],
          },
        ],
        access_key_id: [
          'access_key_id',
          {
            rules: [
              { required: true, message: this.$t('scope.text_913') },
            ],
          },
        ],
        access_key_secret: [
          'access_key_secret',
          {
            rules: [
              { required: true, message: this.$t('scope.text_914') },
            ],
          },
        ],
        enable_auto_sync: [
          'enable_auto_sync',
          {
            valuePropName: 'checked',
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      offsetLayout: {
        wrapperCol: {
          offset: 4,
        },
      },
      docs: {}, // CLOUDACCOUNT_DOCS,
    }
  },
  methods: {
    doAssociate (data) {
      return new this.$Manager('customers').performAction({
        action: 'attach-sub-account',
        id: this.params.data[0].id,
        data: data,
      })
    },
    async handleTest () {
      this.testLoding = true
      try {
        const values = await this.form.fc.validateFields()
        const data = {
          ...values,
          enabled: true,
          provider: 'Aliyun',
        }
        await new this.$Manager('cloudaccounts').performClassAction({
          action: 'check-create-data',
          data: data,
        })
        this.$notification.success({
          message: this.$t('scope.text_525'),
          description: this.$t('scope.text_915'),
        })
      } catch (err) {
        throw err
      } finally {
        this.testLoding = false
      }
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doAssociate({ ...values, provider: 'Aliyun' })
        this.$message.success(this.$t('scope.text_916'))
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
